import styled from 'styled-components';

export const Container = styled.div`
  min-height: 550px;

  display: flex;
  justify-content: space-between;

  h2 {
    font-family: 'Roboto';
    font-style: normal;
    font-weight: 700;
    font-size: 18px;
    line-height: 28px;
    color: #212b36;
  }
`;
